export const MAXLENGTH = 250